<p-toast
  key="customToast"
  [position]="'top-right'"
  [showTransformOptions]="'translateY(100%)'"
  [showTransitionOptions]="'1000ms'"
  [hideTransitionOptions]="'100ms'"
  [showTransformOptions]="'translateX(100%)'"
>
  <ng-template
    pTemplate="message"
    let-message
  >
    <div class="main-container flex items-start gap-spacing-xs">
      <i
        [ngClass]="{
          'icon-check-circle-solid': message.severity === 'success',
          'icon-info': message.severity === 'info',
          'icon-warning': message.severity === 'warn',
          'icon-x-circle': message.severity === 'error'
        }"
        class="flex align-items-center justify-content-center"
      ></i>
      <div class="flex gap-spacing-default flex-column">
        <div class="label-large-bold">
          {{ message.summary }}
        </div>
        <div class="label-large-regular">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
